<template>
  <!-- Ícone de ajuda: o conteúdo do tooltip só entra no DOM ao passar o mouse. -->
  <v-tooltip :top="!bottom" :bottom="bottom" :max-width="maxWidth">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" :small="!xSmall" :x-small="xSmall" class="ajuda-tooltip" :color="color">
        mdi-help-circle-outline
      </v-icon>
    </template>
    <span class="ajuda-tooltip__texto">{{ texto }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AjudaTooltip',
  props: {
    texto: { type: String, required: true },
    bottom: { type: Boolean, default: false },
    xSmall: { type: Boolean, default: false },
    maxWidth: { type: [Number, String], default: 360 },
    // Sobre fundo escuro (toolbar de dialog) o cinza some: passar "white".
    color: { type: String, default: 'grey darken-1' },
  },
};
</script>

<style scoped>
.ajuda-tooltip {
  cursor: help;
  vertical-align: middle;
}
.ajuda-tooltip__texto {
  white-space: pre-line;
}
</style>
